export const isOpaqueShareToken = token => /^[0-9a-f]{24}$/.test(token || '')

export function assertShareCardPayload(payload) {
  const topLevel = Object.keys(payload || {}).sort().join(',')
  const fragranceLevel = Object.keys(payload?.fragrance || {}).sort().join(',')
  if (topLevel !== 'fragrance,link,sharer_name,status' || fragranceLevel !== 'house,image,name'
      || payload.status !== 'wearing today') throw new Error('Share payload failed the privacy allowlist.')
  return payload
}

export function shareTokenFromPayload(payload) {
  const token = new URL(payload.link).pathname.split('/').pop()
  if (!isOpaqueShareToken(token)) throw new Error('Invalid share link.')
  return token
}

export function createShareLoops(client) {
  async function rpc(name, args) {
    const { data, error } = await client.rpc(name, args)
    if (error) throw error
    return data
  }
  return {
    async prepare(fragranceId) {
      return assertShareCardPayload(await rpc('prepare_share_card', { p_fragrance_id: fragranceId }))
    },
    async resolve(token) {
      return assertShareCardPayload(await rpc('resolve_share_card', { p_token: token }))
    },
    confirm(payload) {
      return rpc('confirm_share_card', { p_token: shareTokenFromPayload(payload) })
    },
    async signup(token, userId) {
      if (!isOpaqueShareToken(token) || !userId) return null
      // The database derives the recipient from auth.uid(), never this argument.
      return rpc('record_share_signup', { p_token: token })
    },
  }
}
